var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.598 10.181h-9.545v4.092h5.41c-.866 2.727-3.002 3.636-5.454 3.636a5.908 5.908 0 1 1 3.793-10.433l2.973-2.831A10 10 0 1 0 12.009 22c5.514 0 10.5-3.636 9.588-11.819Z",
    fill: "#777E91"
  })));
};
export default SvgLine;